import React from "react";
import SubheadingText from "./Subheading";
import ParagraphText from "./Paragraph";
import LotusWebcam from "./LotusWebcam";
import HeadingGif from "./Heading-Gif";
import { Wrapper, Break } from "../styles/components/Global/Global";

const SectionPast = () => {
  return (
    <Wrapper>
      <Wrapper $margin>
        <Break $size="small" $desktop />
        <HeadingGif />
        <Break $size="small" $desktop />
        <SubheadingText
          text="Ksawery’s work collaborations have been with some of leading galleries and contemporary art institutions, including Nxt Museum Amsterdam and Khroma Berlin. Naturally, stepping into the realm of commercial client collaboration was a rare exception, but one he was very happy to take on considering Lotus played a pivotal role in early inspirations for his aesthetics. "
          width="small"
          textAlign="left"
        />
        <Break $size="small" />
        <ParagraphText
          text="“I was a huge fan of this racing game they worked on, Lotus Turbo Challenge ©.” The game was developed by Magnetic Fields and released in the late 1980s in collaboration with the iconic British carmaker. "
          width="xlarge"
          align="flex-start"
          size="large"
          textAlign="left"
          weight="bold"
        />
        <Break $size="small" $mobile />
        <ParagraphText
          text="The game was well-received for its fast-paced gameplay, smooth controls,"
          width="small"
          textAlign="left"
        />
        <Break $size="medium" />
      </Wrapper>
      <Wrapper>
        <LotusWebcam />
      </Wrapper>
    </Wrapper>
  );
};

export default SectionPast;
